import {WlMonoSelect} from "./monoselect.component";

export * from './monoselect.component';
export default WlMonoSelect;

customElements.define('wl-monoselect', WlMonoSelect);